import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Collapse, Typography, IconButton, Box, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EmailDropZone from './EmailDropZone';
import GroupDropZone from './GroupDropZone';
import { ChartPropertiesProps } from '../../../redux/ChartPoperties/ChartPropertiesInterfaces';
import { ChartControl } from '../../../redux/ChartPoperties/ChartControlsInterface';
import {
  removeRowSecurityFilter,
  setCurrentOperator,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { AxisType } from '../../CommonFunctions/aliases';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const RowLevelSecurity = ({
  propKey,
  chartProperties,
  chartControls,
  chartFilterGroup,
}: {
  propKey: string;
  chartProperties: ChartPropertiesProps;
  chartControls: ChartControl;
  chartFilterGroup: any;
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const currentOperator =
    chartControls?.properties[propKey]?.rowSecurity?.currentOperator || 'User';
  const dimensionFieldsName: string[] = [
    AxisType.Row,
    AxisType.Column,
    AxisType.Dimension,
    AxisType.SplitBy,
    AxisType.Location,
  ];
  const dimensionAxis = chartProperties.properties[propKey].chartAxes.filter((axis: any) => {
    return dimensionFieldsName.includes(axis.name);
  });
  const dimensionAxisFields = dimensionAxis.flatMap((axis: any) => axis.fields);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'start',
          padding: '10px 5px',
          marginTop: '10px',
        }}
      >
        <Typography
          onClick={() => setIsOpen((prev) => !prev)}
          className="optionDescription"
          style={{
            marginTop: '0px',
            paddingTop: '0.25rem',
            paddingBottom: '0',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Dimension Level Control{' '}
          <Tooltip
            title="Row Level Security"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
            placement="top"
            arrow
          >
            <InfoOutlineIcon
              fontSize="small"
              style={{
                marginLeft: '4px',
                verticalAlign: 'middle',
                color: '#888',
              }}
            />
          </Tooltip>
        </Typography>
        <IconButton
          size="small"
          onClick={() => {
            dispatch(removeRowSecurityFilter(propKey));
          }}
          sx={{
            padding: '5px 2px 2px 2px',
            marginLeft: '5px',
            color: 'lightgray',
            '&:hover': {
              color: 'gray',
              backgroundColor: 'transparent',
            },
          }}
          title="Reset Dimension Level Control"
        >
          <RestartAltIcon style={{ fontSize: 16, color: 'gray' }} />
        </IconButton>
        <IconButton onClick={() => setIsOpen((prev) => !prev)} size="small">
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={isOpen}>
        {dimensionAxisFields.length > 0 ? (
          <>
            <div style={{ display: 'flex', width: '96%' }}>
              <>
                <div
                  onClick={() => dispatch(setCurrentOperator(propKey, 'User'))}
                  style={{
                    borderRadius: '5px 0 0 5px',
                    cursor: 'pointer',
                    marginLeft: '10px',
                    marginBottom: '5px',
                    transition: '0.2s',
                    backgroundColor: currentOperator === 'User' ? '#E0E0E0' : 'white',
                  }}
                  className={currentOperator === 'User' ? 'radioButtonSelected' : 'radioButton'}
                >
                  User
                </div>

                <div
                  // onClick={() => dispatch(setCurrentOperator(propKey, 'Group'))}
                  style={{
                    borderRadius: '0 5px 5px 0',
                    cursor: 'pointer',
                    marginBottom: '10px',
                    transition: '0.2s',
                    backgroundColor: currentOperator === 'Group' ? '#E0E0E0' : 'white',
                  }}
                  className={currentOperator === 'Group' ? 'radioButtonSelected' : 'radioButton'}
                >
                  Group
                </div>
              </>
            </div>

            {currentOperator === 'User' && (
              <>
                <div
                  className="optionDescription"
                  style={{
                    borderTop: '2px solid rgb(224, 224, 224)',
                    paddingTop: '10px',
                    marginTop: '5px',
                    width: '95%',
                    justifySelf: 'center',
                  }}
                >
                  User Emails
                </div>
                <div style={{ margin: '0 1%' }}>
                  <EmailDropZone propKey={propKey} chartControls={chartControls} />
                </div>
              </>
            )}

            {currentOperator === 'Group' && (
              <>
                <div
                  className="optionDescription"
                  style={{
                    borderTop: '2px solid rgb(224, 224, 224)',
                    paddingTop: '10px',
                    marginTop: '5px',
                    width: '95%',
                    justifySelf: 'center',
                  }}
                >
                  Group Name
                </div>

                <div style={{ margin: '0 1%' }}>
                  <GroupDropZone propKey={propKey}>
                    <div
                      style={{
                        // paddingTop: "10px",
                        width: '95%',
                        justifySelf: 'center',
                        minHeight: '60px',
                        textAlign: 'center',
                        padding: '10px',
                      }}
                    >
                      Drop Groups field or flow here
                    </div>
                  </GroupDropZone>
                </div>
              </>
            )}
          </>
        ) : (
          <div style={{ padding: '8px' }}>
            <div
              style={{
                fontSize: '12px',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ddd',
              }}
            >
              {dimensionAxis.length > 0
                ? 'Add atleast one dimension to use Dimension Level Control (RLS)'
                : 'Dimension Level Control (RLS) is not available for this chart'}
            </div>
          </div>
        )}
      </Collapse>
    </>
  );
};

export default RowLevelSecurity;
